<template>
    <div class="test-list">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>用户分组信息</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="search" style="align-items: center;">
            <!-- <div><el-button type="success" size="small" @click.native="clickAdd">添加用户到分组</el-button></div> -->
        </div>
        <div class="list" style="margin-top: 20px;">
            <el-table :data="allGrouping" style="width: 100%" size="mini" stripe :row-class-name="tableRowClassName">
                <el-table-column prop="id" label="分组id" width="100"></el-table-column>
                <el-table-column prop="name" label="用户分组名" width="300"></el-table-column>
                <el-table-column prop="description" label="用户分组描述" width="300"></el-table-column>
                <el-table-column prop="created_at" label="用户分组创建时间"></el-table-column>
            </el-table>
        </div>
        <div class="block">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages"
                :page-sizes="[10, 20, 30, 40]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog title="添加数据" :visible.sync="dialogAddData" width="80%" top="6vh" center @close="closeDialogAdd">
            <div class="search">
                <div>
                    <el-input placeholder="请输入内容" prefix-icon="el-icon-search" size="small"
                        v-model="group_name"></el-input>
                </div>
                <div> <el-button type="primary" size="small" @click.native="QueryZY">查询</el-button></div>
                <div style="margin-left:20px;"> <el-button type="success" size="small"
                        @click.native="resettingZY">重置</el-button>
                </div>
            </div>
            <div class="list" style="min-height: 100px;">
                <el-table :data="allGroupInfo" style="width: 100%" :row-class-name="tableRowClassName" size="mini"
                    max-height="300" stripe>
                    <el-table-column prop="id" label="分组id" width="100"></el-table-column>
                    <el-table-column prop="name" label="用户分组名" width="300"></el-table-column>
                    <el-table-column prop="description" label="用户分组描述" width="300"></el-table-column>
                    <el-table-column prop="created_at" label="用户分组创建时间"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="150">
                        <template slot-scope="scope">
                            <el-button type="primary" @click="copyContent(scope.$index, scope.row)">选择</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- <div class="block">
                    <el-pagination @size-change="handleSizeChangeZY" @current-change="handleCurrentChangeZY"
                        :current-page="pagesZY" :page-sizes="[10, 20, 30, 40]" :page-size="limitZY"
                        layout="total, sizes, prev, pager, next, jumper" :total="totalZY">
                    </el-pagination>
                </div> -->
            </div>
            <el-form :model="addData" :rules="rules" ref="addData">
                <el-form-item label="分组号" :label-width="formLabelWidth" prop="group_id">
                    <el-input v-model="addData.group_id" autocomplete="off" placeholder="请输入分组号"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialogAdd">取 消</el-button>
                <el-button type="primary" @click="submitFormAdd">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>


<script>
export default {
    data() {
        return {
            formLabelWidth: '150px',
            pages: 1,
            limit: 10,
            deBugList: [],
            total: 0,
            dateValue: '',
            allGrouping: [],
            dialogAddData: false,
            addData: {
                user_id: '',
                group_id: ''
            },
            rules: {
                group_id: [
                    { required: true, message: '用户组名为必填项', trigger: 'blur' }
                ],
            },
            allGroupInfo: [],
            group_name:''
        }
    },
    created() {
        this.getUserGroupo()
    },
    methods: {
        clickAdd(){
            this.dialogAddData = true
            this.getAllGrouping()
        },
        getUserGroupo() {
            this.$get(`/v1/admin/group/list-all-groups-for-user?user_id=${this.$route.query.user_id}`, {}).then((res) => {
                if (res.data.status === 'success') {
                    console.log(res.data.data, '======')
                    this.allGrouping = res.data.data
                } else {
                    this.$msg(res.data.msg)
                }
            });
        },
        // getAllGrouping() {
        //     this.$get(`/v1/admin/groups`, {}).then((res) => {
        //         if (res.data.status === 'success') {
        //             this.allGrouping = res.data.data
        //         } else {
        //             this.$msg(res.data.msg)
        //         }
        //     });
        // },
        // getuserGrouping() {
        //     this.$get(`/v1/admin/groups`, {}).then((res) => {
        //         if (res.data.status === 'success') {
        //             this.allGrouping = res.data.data
        //         } else {
        //             this.$msg(res.data.msg)
        //         }
        //     });
        // },
        addAllGrouping(apiData) {
            console.log(apiData)
            apiData.user_id = this.$route.query.user_id
            this.$post(`/v1/admin/groups/users`, apiData).then((res) => {
                if (res.data.status === 'success') {
                    this.dialogAddData = false
                    this.groupData = {
                        group_id: '',
                        user_id: ''
                    }
                    this.getUserGroupo()
                    this.$msg(res.data.msg)
                } else {
                    this.$msg(res.data.msg)
                }
            });
        },
        handleSizeChange(val) {
            console.log(val)
            this.limit = val;
            this.getDeBugList()
        },
        handleCurrentChange(val) {
            this.pages = val;
            this.getDeBugList()
        },
        handleDateChange(value) {
            // 用户选择日期后触发的方法
            const year = value.getFullYear();
            const month = value.getMonth() + 1; // 月份是从0开始的，所以需要加1
            const day = value.getDate();
            const selectedDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;
            this.dateValue = selectedDate
            console.log(this.dateValue)
        },
        Query() {
            this.pages = 1
            this.getDeBugList(); // 使用选择的日期发起请求
        },
        resetting() {
            this.pages = 1
            this.dateValue = ''
            this.getDeBugList()
        },
        tableRowClassName({ row, rowIndex }) {
            if (rowIndex % 2 === 1) {
                return '';
            } else {
                return 'success-row';
            }
        },
        closeDialogAdd() {
            this.dialogAddData = false
            this.addData = {
                group_name: '',
                description: ''
            }
        },
        submitFormAdd() {
            this.$refs.addData.validate((valid) => {
                if (valid) {
                    this.addAllGrouping(this.addData)
                } else {
                    this.$message.error('请输入内容!')
                    return false;
                }
            });
        },
        clickLook(index, row) {
            console.log(index, row)
            this.$router.push({
                path: '/user_grouping_details',
                query: {
                    group_id: row.id,
                }
            });
            this.$get(`/v1/admin/groups/list-group-members?group_id=${row.id}`, {}).then((res) => {
                if (res.data.status === 'success') {
                    console.log(res.data.data, '0000000000000000')
                } else {
                    this.$msg(res.data.msg)
                }
            });
        },
        getAllGrouping() {
            this.$get(`/v1/admin/groups?group_name=${this.group_name}`, {}).then((res) => {
                if (res.data.status === 'success') {
                    this.allGroupInfo = res.data.data
                } else {
                    this.$msg(res.data.msg)
                }
            });
        },
        QueryZY(){
            this.getAllGrouping()
        },
        resettingZY(){
            this.group_name = ''
            this.getAllGrouping()
        },
        copyContent(index,row){
            console.log(index,row)
            this.addData.group_id = row.id
        }
    }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.flex_box{
    margin: 12px;
    text-align right
}

.flex_box div {
    margin 10px
}

.right_box div {
    margin 10px
}
.right_box{
    color: red;
}

.dialog_style{
    display flex
    align-items center
    justify-content center
    font-size 19px
    color #000
}

   .el-select .el-input {
      width: 200px;
    }
  .test-list
      .el-table .warning-row {
        background: oldlace;
      }
  
      .el-table .success-row {
        background: #f0f9eb;
      }
  
      .search
        margin 20px 0
        display flex
        justify-content flex-start
        input
          width 220px
          margin-right 20px
        .add
          padding-left 100px
  
      .list
        min-height 550px
        border 1px solid #EBEEF5
        .edit_icon
          width 20px
          height 20px
          margin-left 16px
          border 1px solid  #ccc
          border-radius 4px
  
  </style>
<style scoped>
.custom-content {
    display: -webkit-box;
    /* 作为弹性盒子模型显示 */
    -webkit-box-orient: vertical;
    /* 设置弹性盒子主轴方向为垂直 */
    overflow: hidden;
    /* 隐藏超出内容 */
    text-overflow: ellipsis;
    /* 在内容超出时显示省略号（但此属性在此场景下可能不直接生效，由-webkit-line-clamp处理） */
    max-height: 100px;
    /* 设置最大高度，与行数限制共同决定最终显示效果 */
    line-height: normal;
}
</style>


// WEBPACK FOOTER //
// src/pages/UserManage/userGroupDetails.vue